import type { RouteRecordRaw } from 'vue-router'
import { TICKETS_ROUTES } from '@/router/routes.enum'
import { reservationsRoutes } from '@/tickets/modules/reservations/reservations.routes'

const isReservationsEnabled = import.meta.env.VITE_FEATURES_RESERVATIONS === 'true'

export const ticketsRoutes: RouteRecordRaw[] = [
  {
    path: '/orders/new',
    name: TICKETS_ROUTES.ORDER_NEW,
    component: () => import('@/tickets/modules/orders/views/CreateTicketOrder.view.vue')
  },
  ...(isReservationsEnabled ? reservationsRoutes : []),
  {
    path: '/orders/:id/confirmation',
    name: TICKETS_ROUTES.ORDER_CONFIRMATION,
    component: () => import('@/tickets/modules/orders/views/TicketOrderConfirmation.view.vue'),
    props: true
  },
  {
    path: '/',
    name: TICKETS_ROUTES.TICKETS_HOME,
    component: () => import('@/tickets/modules/orders/views/CreateTicketOrder.view.vue')
  },
  {
    path: '/404',
    name: TICKETS_ROUTES.NOT_FOUND,
    component: () => import('@/my/modules/auth/views/NotFound.view.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]
